import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useEducation } from "../../hooks/usePortfolioData";
import { FaGraduationCap, FaCertificate, FaMapMarkerAlt, FaLink } from "react-icons/fa";
import "./Education.css";

function Education() {
  const { education, loading, error } = useEducation();

  if (loading) {
    return (
      <Container>
        <div className="text-center" style={{ color: "white", padding: "20px" }}>
          Loading education...
        </div>
      </Container>
    );
  }

  if (error || !education || education.length === 0) {
    return null; // Don't show anything if no education
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Present';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  const isInProgress = (endDate) => {
    return !endDate || endDate === null;
  };

  return (
    <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
      <h1 className="project-heading">
        <FaGraduationCap style={{ marginRight: '15px', color: '#4e69c3' }} />
        Education & <strong className="purple">Qualifications</strong>
      </h1>
      
      <Row className="justify-content-center">
        <Col md={10}>
          <div className="education-timeline">
            {education.map((edu, index) => (
              <div key={edu.id} className={`education-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="education-marker">
                  <FaGraduationCap />
                </div>
                
                <div className="education-content-card">
                  <div className="education-header">
                    <div className="education-degree-row">
                      <h3 className="education-degree">{edu.degree}</h3>
                      {isInProgress(edu.end_date) && (
                        <span className="in-progress-badge">In Progress</span>
                      )}
                    </div>
                    {edu.field_of_study && (
                      <p className="education-field">
                        <span className="purple">in</span> {edu.field_of_study}
                      </p>
                    )}
                  </div>

                  <div className="education-institution-row">
                    {edu.institution_website ? (
                      <a 
                        href={edu.institution_website} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="education-institution"
                      >
                        <FaGraduationCap className="institution-icon" />
                        {edu.institution}
                        <FaLink className="link-icon" />
                      </a>
                    ) : (
                      <div className="education-institution">
                        <FaGraduationCap className="institution-icon" />
                        {edu.institution}
                      </div>
                    )}
                  </div>

                  {(edu.location || edu.grade_gpa) && (
                    <div className="education-meta">
                      {edu.location && (
                        <span className="education-location">
                          <FaMapMarkerAlt /> {edu.location}
                        </span>
                      )}
                      {edu.grade_gpa && (
                        <span className="education-grade">
                          <FaCertificate /> {edu.grade_gpa}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="education-dates">
                    <span className="date-badge">
                      {formatDate(edu.start_date)} - {isInProgress(edu.end_date) ? (
                        <span className="current-badge">Present</span>
                      ) : (
                        formatDate(edu.end_date)
                      )}
                    </span>
                  </div>

                  {edu.description && (
                    <div 
                      className="education-description"
                      dangerouslySetInnerHTML={{ __html: edu.description }}
                    />
                  )}

                  {edu.certificate_url && (
                    <div className="education-certificate">
                      <a 
                        href={edu.certificate_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="certificate-link"
                      >
                        <FaCertificate /> View Certificate
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Education;

